import React, { useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";
import { Form, Button } from "react-bootstrap";
import { KeyRound, Lock, CheckCircle } from "lucide-react"; // 🌟 Luxury studio icons

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!currentPassword) {
      newErrors.currentPassword = "Please Enter Current Password";
    } else if (currentPassword.length < 6) {
      newErrors.currentPassword = "Current Password must be at least 6 characters";
    }

    if (!newPassword) {
      newErrors.newPassword = "Please Enter New Password";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "New Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please Enter Confirm Password";
    }

    if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "New Password & Confirm Password must be same";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    const payload = {
      newPassword,
      currentPassword,
      confirmPassword,
    };

    try {
      const res = await userAPI.updatePassword(payload);
      if (res.code === 200) {
        showSuccess(res.message || "Security credentials updated cleanly");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setErrors({});
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="orangeapes-account-dashboard-wrapper mb-5">
        <div className="orangeapes-account-settings-box p-4 p-md-5">
          
          {/* HEADER SECTOR */}
          <div className="account-section-header mb-5">
            <h5 className="orangeapes-dashboard-main-title mb-2">Security Vault Settings</h5>
            <p className="orangeapes-dashboard-subtitle">
              Update your security keys credentials configuration to guard your profile matrix.
            </p>
          </div>

          <Form onSubmit={handleDetailsSubmit} className="orangeapes-dashboard-form">
            
            {/* CURRENT PASSWORD FIELD */}
            <Form.Group className="orangeapes-input-group-row mb-4" controlId="currentPassword">
              <Form.Label className="orangeapes-form-custom-label">
                Current Password <span className="text-orange-token">*</span>
              </Form.Label>
              <div className="orangeapes-field-input-wrapper">
                <KeyRound size={16} className="orangeapes-field-icon" />
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  className="orangeapes-blank-input"
                />
              </div>
              {errors && errors.currentPassword && (
                <span className="orangeapes-error-validation-msg">{errors.currentPassword}</span>
              )}
            </Form.Group>

            {/* NEW PASSWORD FIELD */}
            <Form.Group className="orangeapes-input-group-row mb-4" controlId="newPassword">
              <Form.Label className="orangeapes-form-custom-label">
                New Password <span className="text-orange-token">*</span>
              </Form.Label>
              <div className="orangeapes-field-input-wrapper">
                <Lock size={16} className="orangeapes-field-icon" />
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="orangeapes-blank-input"
                />
              </div>
              {errors && errors.newPassword && (
                <span className="orangeapes-error-validation-msg">{errors.newPassword}</span>
              )}
            </Form.Group>

            {/* CONFIRM PASSWORD FIELD */}
            <Form.Group className="orangeapes-input-group-row mb-5" controlId="confirmPassword">
              <Form.Label className="orangeapes-form-custom-label">
                Confirm New Password <span className="text-orange-token">*</span>
              </Form.Label>
              <div className="orangeapes-field-input-wrapper">
                <Lock size={16} className="orangeapes-field-icon" />
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="orangeapes-blank-input"
                />
              </div>
              {errors && errors.confirmPassword && (
                <span className="orangeapes-error-validation-msg">{errors.confirmPassword}</span>
              )}
            </Form.Group>

            {/* SUBMIT RE-CREDENTIALS ACCENTS */}
            <div className="d-flex justify-content-start">
              <Button
                className="orangeapes-dashboard-submit-btn py-3 px-5 d-flex align-items-center gap-2"
                type="submit"
              >
                <span>UPDATE VAULT PASSWORD</span>
                <CheckCircle size={14} />
              </Button>
            </div>

          </Form>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;